import React from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { format } from "date-fns";

const ContactUsDetailsModal = ({
  showDetailsModal,
  setShowDetailsModal,
  selectedData,
  setSelectedData,
}) => {
  const handleCloseDetailsModal = () => {
    setSelectedData({});
    setShowDetailsModal(false);
  };

  return (
    <Modal
      show={showDetailsModal}
      onHide={handleCloseDetailsModal}
      size="lg"
      centered
    >
      <Modal.Header closeButton className="bg-dark text-light">
        <Modal.Title>Contact-Us Details</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark">
        <Row className="mb-3">
          {Object.entries({
            Name: `${selectedData.first_name || ""} ${selectedData.last_name || ""}`,
            Email: selectedData.email || "",
            Category: selectedData.category || "",
            Date:
              selectedData?.createdAt && format(selectedData?.createdAt, "PP"),
          }).map(([key, value]) => (
            <Col xs={12} md={12} lg={6} className="mb-3" key={key}>
              <div className="p-3 bg-secondary bg-opacity-10 rounded">
                <span className="text-secondary fs-6 fw-semibold">{key}</span>
                <span className="d-block fs-5 fw-medium text-light">
                  {value}
                </span>
              </div>
            </Col>
          ))}
          <Col xs={12} md={12} lg={12} className="mb-3">
            <div className="p-3 bg-secondary bg-opacity-10 rounded">
              <span className="text-secondary fs-6 fw-semibold">Feedback</span>
              <span className="d-block fs-5 fw-medium text-light">
                {selectedData.message || ""}
              </span>
            </div>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer className="bg-dark text-light">
        <Button variant="secondary" onClick={handleCloseDetailsModal}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default ContactUsDetailsModal;
